export default "__VITE_ASSET__DjSCfp$j__"